import { Modal, ListGroup, ListGroupItem } from "react-bootstrap";
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormattedMessage } from "react-intl";
import * as downloaderActions from "../../utils/downloader/downloaderActions";

class DownloaderModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.filterOutFinishedDownloads = this.filterOutFinishedDownloads.bind(
      this
    );
  }

  componentWillMount() {
    /**
     * We check here if a file happens to be in the successDownloads or errorDownloads array,
     * if they are in one of those arrays, it means the download is done, then we clear the
     * ongoing downloads array.
     */
    this.filterOutFinishedDownloads();
  }

  componentDidUpdate() {
    this.filterOutFinishedDownloads();
  }

  filterOutFinishedDownloads() {

    if (
      (this.props.currentDownloads.length > 0 &&
        this.props.successDownloads.length > 0) ||
      (this.props.currentDownloads.length > 0 &&
        this.props.errorDownloads.length > 0)
    ) {
      let finishedDownload = this.props.currentDownloads.find(
        (currentDownloadFile) =>
          this.props.successDownloads.some(
            (file) => file.path == currentDownloadFile.path
          )
      );

      if (!finishedDownload) {
        finishedDownload = this.props.currentDownloads.find(
          (currentDownloadFile) =>
            this.props.errorDownloads.some(
              (file) => file.path == currentDownloadFile.path
            )
        ); // Look also in error downloads.
      }

      if (finishedDownload) {
        this.props.downloaderActions.clearOngoing(finishedDownload.path);
      }
    }
  }

  render() {
    return (
      <Modal show={this.props.showDownloadsModal} onHide={this.props.onClose}>
        <div className="modal-main">
          <Modal.Header>
            <Modal.Title>{this.props.showDownloadsTitle}</Modal.Title>
            <span className="close" onClick={this.props.onClose} />
          </Modal.Header>

          <Modal.Body>
            <ListGroup>
              {this.props.currentDownloads.length > 0 ? (
                this.props.currentDownloads.map((file) => {
                  return (
                    <ListGroupItem key={file.path}>
                      {file.identifier}
                    </ListGroupItem>
                  );
                })
              ) : (
                <FormattedMessage id="downloadsModal.noDownloads" />
              )}
            </ListGroup>
          </Modal.Body>
        </div>
      </Modal>
    );
  }
}

DownloaderModal.propTypes = {
  currentDownloads: PropTypes.array,
  successDownloads: PropTypes.array,
  errorDownloads: PropTypes.array,
  downloaderActions: PropTypes.object,
  showDownloadsModal: PropTypes.bool,
  showDownloadsTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClose: PropTypes.func
};

function mapStateToProps(state) {
  const downloads = state.downloader || {};

  return {
    currentDownloads: downloads.files || [],
    errorDownloads: downloads.errorDownloads || [],
    successDownloads: downloads.successDownloads || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    downloaderActions: bindActionCreators(downloaderActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DownloaderModal);



// WEBPACK FOOTER //
// ./src/components/common/DownloaderModal.js